import styled from "styled-components/native";
import { get } from "lodash";
import { Link } from "../../../link";
import { StyledLinkProps } from "./types";
import { AlertInlineTypes, AlertInlineVariants } from "../../types";
import { getPressableColor } from "../../utils/getPressableColor";
import { Theme } from "../../../../theming/types";
import { EventsState } from "../../../../hooks/useEvents";

type StyledLinkThemeProps = StyledLinkProps & { theme: Theme };

export const StyledLink = styled(Link)<StyledLinkProps>`
  color: ${({
    type = "floating",
    variant = "success",
    events,
    theme
  }: StyledLinkThemeProps) =>
    get(
      theme.colors,
      getPressableColor(
        type as AlertInlineTypes,
        variant as AlertInlineVariants,
        events as EventsState
      )
    )};
  text-decoration: underline;
  text-decoration-color: ${({
    type = "floating",
    variant,
    events,
    theme
  }: StyledLinkThemeProps) =>
    get(
      theme.colors,
      getPressableColor(
        type as AlertInlineTypes,
        variant as AlertInlineVariants,
        events as EventsState
      )
    )};
  line-height: 16px;
`;
